import React from 'react';
import emailjs from '@emailjs/browser';
// Initialize EmailJS with your user ID
// You'll need to replace this with your actual EmailJS user ID in production
emailjs.init('your_user_id');
// Create a helper function to send emails
export const sendEmail = templateParams => {
  return emailjs.send('service_id',
  // Replace with your EmailJS service ID in production
  'template_id',
  // Replace with your EmailJS template ID in production
  templateParams, 'public_key' // Replace with your EmailJS public key in production
  );
};